import { Link } from 'react-router-dom';
import { siteConfig } from '@/mocks/siteConfig';
import { categoryData } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full px-4 md:px-6">
        <div className="py-12 md:py-16">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <Link to="/" className="no-underline">
                <h3 className="text-xl font-bold text-foreground-950 font-[var(--font-heading)] mb-3">
                  久久网
                </h3>
              </Link>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {siteConfig.tagline}
              </p>
              <p className="text-sm text-foreground-600 mt-2">
                一站式综合网络平台，汇聚海量优质内容资源
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-900 mb-4">内容分类</h4>
              <ul className="space-y-2">
                {categoryData.map((cat) => (
                  <li key={cat.id}>
                    <Link
                      to={`/category/${cat.id}`}
                      className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-900 mb-4">快速链接</h4>
              <ul className="space-y-2">
                <li>
                  <Link
                    to="/"
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200"
                  >
                    首页
                  </Link>
                </li>
                <li>
                  <Link
                    to="/about"
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200"
                  >
                    关于我们
                  </Link>
                </li>
                <li>
                  <Link
                    to="/about"
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200"
                  >
                    联系我们
                  </Link>
                </li>
                <li>
                  <Link
                    to="/about"
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200"
                  >
                    品牌信誉
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-900 mb-4">联系方式</h4>
              <ul className="space-y-2">
                <li className="flex items-center gap-2 text-sm text-foreground-600">
                  <i className="ri-mail-line text-foreground-500"></i>
                  <span>{siteConfig.email}</span>
                </li>
                <li className="flex items-center gap-2 text-sm text-foreground-600">
                  <i className="ri-phone-line text-foreground-500"></i>
                  <span>{siteConfig.phone}</span>
                </li>
                <li className="flex items-center gap-2 text-sm text-foreground-600">
                  <i className="ri-map-pin-line text-foreground-500"></i>
                  <span>{siteConfig.address}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="py-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 久久网 版权所有 | 京ICP备2024XXXXXXXX号
          </p>
          <div className="flex items-center gap-4">
            <a
              href="https://weibo.com"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="text-foreground-500 hover:text-primary-500 transition-colors"
              aria-label="微博"
            >
              <i className="ri-weibo-line text-lg"></i>
            </a>
            <a
              href="https://weixin.qq.com"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="text-foreground-500 hover:text-primary-500 transition-colors"
              aria-label="微信"
            >
              <i className="ri-wechat-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}